<odx-modal-header>
  <odx-area-header i18n="@@monitoring.productSearch.selectPlaceholderCategory.header">Produktkategorie auswählen</odx-area-header>
</odx-modal-header>
<odx-modal-content>
  <p i18n="@@monitoring.productSearch.selectPlaceholderCategory">
    Bitte wählen Sie die Produktkategorie aus, für die Sie einen Platzhalter erstellen möchten.
  </p>
  <form odxForm [formGroup]="categoryForm">
    <odx-form-field>
      <odx-select formControlName="category" odxFormFieldControl>
        @for (category of categories; track category) {
          <odx-select-option [value]="category">
            {{ categoryLabels[category] }}
          </odx-select-option>
        }
      </odx-select>
    </odx-form-field>
  </form>
</odx-modal-content>
<odx-modal-footer>
  <button
    odxButton
    variant="primary"
    (click)="onConfirm()"
    i18n="@@monitoring.productSearch.selectPlaceholderCategory.button.confirm"
  >
    OK
  </button>
</odx-modal-footer>
